export const tipoSolicitudCambioCic = {
  TrasladarInformacionCrediticiaDeUnDeudorAOtro: 1,
  ModificarOEliminarCuotasAtrasadas: 2,
  ModificarOEliminarCuentasPorCobrarAsociadas: 3,
  ModificarMotivoDeLiquidacion: 4,
  IncluirMotivoDeLiquidacion: 5,
  EliminarOperacion: 7,
  ExcluirOSustituirCodeudor: 8,
};
